PJQ.views.settings.ChangeRequestSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'change-requests'),
        model: null,
        customFields: null
    },
    events: {},
    beforeFirstRender: function () {
        this.listenTo(this.model, 'fetch', this.render);
    },
    afterRender: function () {
        new PJQ.views.settings.NumberFormatInput({
            el: this.$('.number-format'),
            settings: this.model,
            customFields: this.options.customFields,
            onSave: (value) => {
                this.model.set('numberFormat', value);
                this.onChange();
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-line-item-order-by'),
            defaultValue: this.model.get('lineItemOrderBy'),
            onChange: _.bind(function (value) {
                this.model.set('lineItemOrderBy', value);
                this.onChange();
            }, this)
        });
    },
    onChange: function (model) {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(model ? model : this.model);
        }
    }
});